import {Component, OnInit, ViewEncapsulation, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatabaseService} from 'app/database.service';
import {SwiperComponent} from 'ngx-swiper-wrapper';
import {DomSanitizer} from '@angular/platform-browser';

declare var jQuery: any;
var perra_inicializada_1 = false;

@Component({
    selector: 'app-collection',
    templateUrl: './collection.component.html',
    styleUrls: ['./collection.component.scss'],
    encapsulation: ViewEncapsulation.None,
})


export class CollectionComponent implements OnInit {
    showDetail: boolean;
    showInfo: boolean;

    @ViewChild('projectsSwiper') projectsSwiper: SwiperComponent;


    collection: any;
    sub: any;
    slug: any;
    activeProject: any;
    index: any;

    swiperConfig: Object = {
        // pagination: '.swiper-pagination',
        // paginationClickable: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 30,
    };

    constructor(
        private route: ActivatedRoute,
        private database: DatabaseService,
        protected sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        perra_inicializada_1 = false;

        this.sub = this.route.params.subscribe(params => {
            this.slug = params['slug'];

            this.collection = this.database.collections.find(collection => collection.slug === this.slug);

            this.activeProject = this.collection.projects[0];

            // console.log(this.activeProject);

        });


    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    goToSlide(i) {
        this.index = i;
        this.activeProject = this.collection.projects[i];
    }


    slideChanged() {
        // console.log('slide changed', this.index);
        this.activeProject = this.collection.projects[this.index];
    }

    showProjectDetail() {
        this.showDetail = true;
    }

    ngAfterViewInit() {
        console.log("after collect----------------");
        setInterval(function () {

            var height = window.innerHeight;
            var width = window.innerWidth;
            if (height <=637) {
                console.log("entro aqi ----------");
                
                var element = document.getElementsByClassName("mt-4");
                 if (element.length > 0) {
                     
                element[0].classList.add("pantalla-widescreen");
                 }
            } else {
                var element = document.getElementsByClassName("mt-4");
                if (element.length > 0) {
                    element[0].classList.remove("pantalla-widescreen")
                }
            }
        }, 500);
    }


}



// WEBPACK FOOTER //
// ./src/app/collection/collection.component.ts